<template>
  <div class="">
    <div class="specs">
      <!-- <div
        class="hui"
        v-text="sad"
      ></div> -->
      <div
        class="mongolia"
        @click="close_specs"
      ></div>
      <div class="top">
        <div v-show="zeng" class="zeng">此商品含有赠品：每{{zqnum+dan}}赠送{{zengsu+dan}}</div>

        <div class="card">
          <van-card
            @click-thumb="see(img)"
            price="66.00"
            :thumb="img"
          >
            <template #title>
              <div class="title">{{ names }}</div>
            </template>
            <template #price>
               <div class="pricehua" v-show="xiafg">
              

                <span v-show="login == 1">￥{{ xvpice }} </span>
              </div> 
              <div class="price">
                {{ login == 1 ? '￥' + picex : '价格登录可见' }}
               <span v-if="[1,3,51,56,22].indexOf($store.state.shopid)!=-1" style=" margin-left: 1.5rem;">【鲸会员】{{fan+'%'}}</span>
                <span v-else  v-show="login == 1">￥{{ vipp }} <img src="../../../assets/supervip.png" /></span>
                <!-- <span  v-show="login == 1">￥{{ vipp }} <img src="../../../assets/supervip.png" /></span> -->
              </div>
            </template>
            <template #num>
              <div class="knum">
                库存：<span>{{ stock }}</span>
                <p>{{ pack }}</p>
              </div>

            </template>

          </van-card>
          <div class="close">
            <van-icon
              @click="close_specs"
              name="cross"
            />
          </div>
        </div>
        <div
          id="vmsimulatedDATA"
          class="productBox"
        >

          <div class="productConten">

            <div
              class="product-delcom"
              v-for="(ProductItem, n) in simulatedDATA.specifications"
              :key="n"
            >
              <p>{{ ProductItem.name }}</p>
              <ul class="product-footerlist clearfix">
                <li
                  v-for="(oItem, index) in ProductItem.item"
                  v-on:click="
                    specificationBtn(oItem.id, n, $event, index, oItem.item)
                  "
                  v-bind:class="[
                    oItem.isShow ? '' : 'noneActive',
                    subIndex[n] == index ? 'productActive' : '',
                  ]"
                  :key="index"
                >
                  {{ oItem.item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr v-show="false" />
        <div
          class="num"
          v-show="fg"
        >
          <p>每支长度(米)：</p>
          <van-stepper
            @change="long"
            input-width="1.92rem"
            button-size="1rem"
            class="stepper"
            step="0.5"
            v-model="lengths"
            decimal-length="2"
            :disabled="lengthsf"

          />
        </div>
        <hr />
        <div class="num" v-if="znum && znum!=0">
          <p>数量：</p>
          <van-stepper
            input-width="1.92rem"
            button-size="1rem"
            class="stepper"
            v-model.number="zcnum"
            @change="kcbz"
            :max="stock"
            :min="mins"
            :step="znum"
            default-value="0"
            :disable-input="zuida==0"
          />
        </div>
        <div class="num" v-else>
          <p>数量：</p>
          <van-stepper
            input-width="1.92rem"
            button-size="1rem"
            class="stepper"
            v-model.number="num"
            @change="kcbz"
            :max="stock"
            :min="mins"
          />
        </div>
        <hr />
        <div class="prices" v-if="znum && znum!=0">
          <div class="p_num">
            数量：<span>{{ zcnum }}</span> 共计：<span>￥{{ login == 1 ? all_money : '价格登录可见' }}</span>
          </div>
        </div>
        <div class="prices" v-else>
          <div class="p_num">
            数量：<span>{{ num }}</span> 共计：<span>￥{{ login == 1 ? all_money : '价格登录可见' }}</span>
          </div>
        </div>
        <div class="buts">
           <div class="but" :class="$route.query.jian?'butt':''">
            <van-button
              type="danger"
              size="large"
              @click="goorder"
            >立即购买</van-button>
          </div>
          <div class="but" v-show="$route.query.jian!=1">
            <van-button
              type="warning"
              size="large"
              @click="gocar"
            >加入购物车</van-button>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Icon, Card, Stepper, Button, ImagePreview, Toast } from 'vant'

Vue.use(Icon)
  .use(Card)
  .use(Stepper)
  .use(Button)
export default {
  props: {
    // specs_show: Boolean
    vip: '',
    level: '',
    head: '',
    moneys: '',
    longs: '',
  },
  created () {
    if (JSON.parse(localStorage.getItem('user')).id != 0) {
      this.login = 1
    } else {
    }
    this.deng()
    // console.log(this.simulatedDATA)
  },
  updeteed () { },
  data () {
    return {
      login: 0,
      // vip: 0,
      // level: '',
      // head: '',
      // moneys: '',
      // longs: '',
      simulatedDATA: {
        // 模拟后台返回的数据 多规格
        difference: [
          // { name: 'xxxx', difference: "1000*200*3000mm 暖白（小浮雕）", id: 131, stock: 10, pice: 1, vip: 0.5, },
          // { name: 'xxxx', difference: "2000*2500*3000mm 暖白（小浮雕）", id: 142, stock: 10, pice: 20000, vip: 0.5, },
          // { name: 'xxxx', difference: "1000*200*3000mm 暖白（浮雕）", id: 231, stock: 0, pice: 3, vip: 0.5, },
          // { name: 'xxxx', difference: "2000*2500*3000mm 暖白（浮雕）", id: 242, stock: 10, pice: 4, vip: 0.5, },
          // { name: 'xxxx', difference: "1000*200*3000mm 暖白（小浮雕） 环保", id: 131, stock: 10, pice: 1, vip: 0.5, },
          // { name: 'xxxx', difference: "2000*2500*3000mm 暖白（小浮雕） 环保", id: 142, stock: 10, pice: 20000, vip: 0.5, },
          // { name: 'xxxx', difference: "1000*200*3000mm 暖白（浮雕） 环保", id: 231, stock: 0, pice: 3, vip: 0.5, },
          // { name: 'xxxx', difference: "2000*2500*3000mm 暖白（浮雕） 环保", id: 242, stock: 10, pice: 4, vip: 0.5, },
          // { name: 'xxxx', difference: "2000*2500*3000mm 暖白（浮雕） 环保", id: 242, stock: 10, pice: 4, vip: 0.5, },
          // { name: 'xxxx', difference: "2000*2500*3000mm", id: 242, stock: 10, pice: 4, vip: 0.5, },
          // { name: 'xxxx', difference: "1000*200*3000mm", id: 22, stock: 10, pice: 1, vip: 0.5, },
        ],
        specifications: [
          // {// 这里是要被渲染字段
          //   'name': '尺寸',
          //   'item': [{ item: "1000*200*3000mm", id: 31, },
          //   { item: "2000*2500*3000mm", id: 42, },]
          // },
          // {
          //   'name': '颜色',
          //   'item': [{ item: "暖白（小浮雕）" },
          //   { item: "暖白（浮雕）" },]
          // },
          // {
          //   'name': '环保',
          //   'item': [{ item: "环保" },
          //   ]
          // },
        ],
      },
      selectArr: [], // 存放被选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中 因为不确定是多规格还是但规格，所以这里定义数组来判断
      shopname: '',
      shopid: '',
      names: '',
      vipp: '',
      pack: '',
      stock: '',
      sku: '',
      gid: '',
      img: '',
      pice: 0,
      num: 1,
      zcnum:0,
      lengths: 1,
      lengthsf: false,
      fg: false, //算不算长度
      lgname: '',
      gui: true, //是否已选
      dan: '', //是否已选
      one: '',
      sad: '',
      picex: 0,
      xiafg:false,
      xiapice:0,
      xvpice:0,
      zhuo:0,
      znum:1,
      jianlou:0,
      mins:1,
      basid:'',
      zeng:0,
      zqnum: 10,
      give:0,
      tf:0,
      fan:0,
      fane:0,
      zengsu: 1,
      zuida:1000000,
    }
  },
  computed: {
    all_money () {
      let money = 0
      if (this.fg) {
      if(this.zhuo==1){
        money = (this.pice * this.zcnum * this.lengths).toFixed(2)
      }else{
        money = (this.pice * this.num * this.lengths).toFixed(2)

      }
      } else {   
        if(this.zhuo==1){
        money = (this.pice * this.zcnum).toFixed(2)
        }  else{
        money = (this.pice * this.num).toFixed(2)

        }  
      }
      if (isNaN(money)) {
        money = 0
      }
      return money
    },
  },
  methods: {
    async deng () {

      await this.axios
        .get('specAndAttr', {
          params: {
            goods_id: this.$route.query.id,
            store_id: this.$route.query.sid ? this.$route.query.sid : this.$store.state.shopid,
          },
        })
        .then((res) => {
          // console.log(res)

          if (res.data.data.length >= 2) {
            let arr0 = []
            for (let a in res.data.data[0].item) {
              arr0.push(res.data.data[0].item[a])
            }
            let arr1 = []

            for (let b in res.data.data[1].item) {
              arr1.push(res.data.data[1].item[b])
            }
            let arr = []
            arr0.forEach((v1, c) => {
              arr.push(v1.id)
            })
            let arrr = []
            arr1.forEach((v2, d) => {
              // arr.push(v.id)
              if (arr.indexOf(v2.id) == -1) {
                arrr.push(arr1.slice(d, d + 1))
              }
            })
            res.data.data[1].item = arrr.flat()
          }
          this.simulatedDATA.specifications = res.data.data
          // console.log(this.longs)

        })
        .catch((ref) => { })
      this.axios
        .get('getGoods', {
          params: {
            goods_id: this.$route.query.id,
            store_id: this.$route.query.sid ? this.$route.query.sid : this.$store.state.shopid,
          },
        })
        .then((res) => {
          // console.log(res)
          this.jianlou=res.data.jianlou
          res.data.data.forEach((v) => {
            // v.sku = v.sku.replaceAll(',', '')
            // console.log(v.sku)
            v.sku = v.sku.split(",").join("");
            // console.log(v.sku.repace(",", ''))
            // v.sku = v.sku.repace(/\,/g, '')
            // if(v.sku.indexOf(',')){

            // }
          })
          // console.log(res)
          this.img = res.data.data[0].sku_thumb
          this.names = this.head
          // this.sad = this.head

          // if (jf) {
          //   this.pice = this.moneys
          // }
          if ([16, 17, 23,30,27].indexOf(this.$store.state.shopid) == -1) {
            this.picex = this.moneys
          } else {
          }
          // if(res.data.data)
          this.simulatedDATA.difference = res.data.data
          for (var i in this.simulatedDATA.difference) {
            this.shopItemInfo[
              this.simulatedDATA.difference[i].sku.trim()
            ] = this.simulatedDATA.difference[i] // 修改数据结构格式，改成键值对的方式，以方便和选中之后的值进行匹配
          }
          // console.log(this.shopItemInfo)
          this.fg = this.longs

          this.checkItem()
        })
        .catch((ref) => { })
    },

    kcbz () {

      if (this.num > this.stock) {
        Toast('库存不足')
        // this.num = this.stock
      }
      // this.num.toFixed(3)
    },
    specificationBtn: function (item, n, event, index, na) {
      var self = this
      if (self.selectArr[n] !== item) {
        self.selectArr[n] = item
        self.subIndex[n] = index
      } else {
        self.selectArr[n] = ''
        self.subIndex[n] = -1 // 去掉选中的颜色
      }
      self.checkItem(na)
    },
    checkItem: function (na) {
      var self = this
      var option = self.simulatedDATA.specifications
      var result = [] // 定义数组存储被选中的值
      // console.log(option)
      let str = ''
      // console.log(self.selectArr)
      self.selectArr.forEach((v) => {
        str = str + v
      })
      let str3 = ''
      self.selectArr.forEach((v) => {
        str3 = v + str3
      })
      // console.log(this.shopItemInfo[str.trim()])
      if (this.shopItemInfo[str.trim()]) {
        if (this.fg) {
          // this.lgname = this.shopItemInfo[str.trim()].title + " " + this.shopItemInfo[str.trim()].guige
          this.lgname = this.head + ' ' + this.shopItemInfo[str.trim()].guige
          this.long('1.0')
        } else {
          // this.names = this.shopItemInfo[str.trim()].title + ' ' + this.shopItemInfo[str.trim()].guige
          this.names = this.head + ' ' + this.shopItemInfo[str.trim()].guige
        }
        this.pack = this.shopItemInfo[str.trim()].sku_packing
        this.dan = this.shopItemInfo[str.trim()].unit
        this.one = this.shopItemInfo[str.trim()].rate
        this.stock = this.shopItemInfo[str.trim()].sku_stock
        this.img = this.shopItemInfo[str.trim()].sku_thumb
        this.gid = this.shopItemInfo[str.trim()].id
        this.sad = this.shopItemInfo[str.trim()].sku_code
        this.xiafg=this.shopItemInfo[str.trim()].isdeleteprice==1
        this.xiapice=this.shopItemInfo[str.trim()].commondeleteprice
        this.xvpice=this.shopItemInfo[str.trim()].superdeleteprice
        this.zhuo=this.shopItemInfo[str.trim()].ishuodong
        this.znum=this.shopItemInfo[str.trim()].huodonggoodsnum
        this.lengthsf=this.shopItemInfo[str.trim()].longgumeizhimishu==0?false:true
        this.lengths=this.shopItemInfo[str.trim()].longgumeizhimishu?this.shopItemInfo[str.trim()].longgumeizhimishu:1
        this.mins=this.shopItemInfo[str.trim()].zuidigoumaishu==0?1:this.shopItemInfo[str.trim()].zuidigoumaishu
        this.basid=this.shopItemInfo[str.trim()].goods_basic_id
        this.zeng=this.shopItemInfo[str.trim()].zengpin
        this.zqnum=this.shopItemInfo[str.trim()].buyzengpinnum
        this.tf=this.shopItemInfo[str.trim()].taocanflag
        this.fan=this.shopItemInfo[str.trim()].fanli_rate
        this.fane=this.shopItemInfo[str.trim()].fanli_enable
        this.zuida=this.shopItemInfo[str.trim()].purchaselimit

        this.zengsu=this.shopItemInfo[str.trim()].zengpinnum
        this.zcnum=this.znum
        // this.sku = this.shopItemInfo[str.trim()].sku_packing
        // console.log(this.level)
        if (this.level == 1) {
          if (this.vip == 0) {
            this.pice = this.shopItemInfo[str.trim()].common_one_price
          } else if (this.vip == 1) {
            this.pice = this.shopItemInfo[str.trim()].vip_one_price
          }
          this.picex = this.shopItemInfo[str.trim()].common_one_price

          this.vipp = this.shopItemInfo[str.trim()].vip_one_price
        } else if (this.level == 2) {
          if (this.vip == 0) {
            this.pice = this.shopItemInfo[str.trim()].common_two_price
          } else if (this.vip == 1) {
            this.pice = this.shopItemInfo[str.trim()].vip_two_price
          }
          this.picex = this.shopItemInfo[str.trim()].common_two_price

          this.vipp = this.shopItemInfo[str.trim()].vip_two_price
        } else if (this.level == 3) {
          if (this.vip == 0) {
            this.pice = this.shopItemInfo[str.trim()].common_three_price
          } else if (this.vip == 1) {
            this.pice = this.shopItemInfo[str.trim()].vip_three_price
          }
          this.picex = this.shopItemInfo[str.trim()].common_three_price

          this.vipp = this.shopItemInfo[str.trim()].vip_three_price
        }
        this.gui = true
      } else if (this.shopItemInfo[str3.trim()]) {

        if (this.fg) {
          // this.lgname = this.shopItemInfo[str3.trim()].title + this.shopItemInfo[str3.trim()].guige
          this.lgname = this.head + this.shopItemInfo[str3.trim()].guige
          this.long('1.0')
        } else {
          // console.log(this.shopItemInfo[str3.trim()])
          // this.names = this.shopItemInfo[str3.trim()].title + ' ' + this.shopItemInfo[str3.trim()].guige
          this.names = this.head + ' ' + this.shopItemInfo[str3.trim()].guige
        }
        this.pack = this.shopItemInfo[str3.trim()].sku_packing
        this.dan = this.shopItemInfo[str3.trim()].unit
        this.one = this.shopItemInfo[str3.trim()].rate
        this.stock = this.shopItemInfo[str3.trim()].sku_stock
        this.img = this.shopItemInfo[str3.trim()].sku_thumb
        this.sad = this.shopItemInfo[str3.trim()].sku_code
        this.gid = this.shopItemInfo[str3.trim()].id
        this.xiafg=this.shopItemInfo[str3.trim()].isdeleteprice==1
        this.xvpice=this.shopItemInfo[str3.trim()].superdeleteprice
        this.xiapice=this.shopItemInfo[str3.trim()].commondeleteprice
        this.znum=this.shopItemInfo[str3.trim()].huodonggoodsnum
        this.zhuo=this.shopItemInfo[str3.trim()].ishuodong
        this.lengthsf=this.shopItemInfo[str3.trim()].longgumeizhimishu==0?false:true
        this.lengths=this.shopItemInfo[str3.trim()].longgumeizhimishu
        this.mins=this.shopItemInfo[str3.trim()].zuidigoumaishu==0?1:this.shopItemInfo[str3.trim()].zuidigoumaishu
        this.basid=this.shopItemInfo[str3.trim()].goods_basic_id
        this.zqnum=this.shopItemInfo[str3.trim()].buyzengpinnum
        this.zeng=this.shopItemInfo[str3.trim()].zengpin
        this.tf=this.shopItemInfo[str3.trim()].taocanflag
        this.fan=this.shopItemInfo[str3.trim()].fanli_rate
        this.fane=this.shopItemInfo[str3.trim()].fanli_enable
        this.zuida=this.shopItemInfo[str3.trim()].purchaselimit
        this.zengsu=this.shopItemInfo[str3.trim()].zengpinnum
        this.zcnum=this.znum
        // this.sku = this.[str3.trim()].sku_packing
        if (this.level == 1) {
          if (this.vip == 0) {
            this.pice = this.shopItemInfo[str3.trim()].common_one_price
          } else if (this.vip == 1) {
            this.pice = this.shopItemInfo[str3.trim()].vip_one_price
          }
          this.picex = this.shopItemInfo[str3.trim()].common_one_price
          this.vipp = this.shopItemInfo[str3.trim()].vip_one_price
        } else if (this.level == 2) {
          if (this.vip == 0) {
            this.pice = this.shopItemInfo[str3.trim()].common_two_price
          } else if (this.vip == 1) {
            this.pice = this.shopItemInfo[str3.trim()].vip_two_price
          }
          this.picex = this.shopItemInfo[str3.trim()].common_two_price
          this.vipp = this.shopItemInfo[str3.trim()].vip_two_price
        } else if (this.level == 3) {
          if (this.vip == 0) {
            this.pice = this.shopItemInfo[str3.trim()].common_three_price
          } else if (this.vip == 1) {
            this.pice = this.shopItemInfo[str3.trim()].vip_three_price
          }
          this.picex = this.shopItemInfo[str3.trim()].common_three_price
          this.vipp = this.shopItemInfo[str3.trim()].vip_three_price
        }
        this.gui = true
      } else {
        this.gui = false
      }
      for (let i in option) {
        // console.log(self.selectArr[i])
        result[i] = self.selectArr[i] ? self.selectArr[i] : ''
      }
      // console.log(option)
      for (let i in option) {
        // console.log(option)
        var last = result[i] // 把选中的值存放到字符串last去
        for (let k in option[i].item) {
          result[i] = option[i].item[k].id // 赋值，存在直接覆盖，不存在往里面添加name值
          // console.log('这里:', JSON.parse(JSON.stringify(result)))
          option[i].item[k].isShow = self.isMay(result) // 在数据里面添加字段isShow来判断是否可以选择
          // console.log(option[i])
        }
        result[i] = last // 还原，目的是记录点下去那个值，避免下一次执行循环时避免被覆盖
      }
      self.$forceUpdate() // 重绘
    },
    isMay: function (result) {
      for (var i in result) {
        if (result[i] === '') {
          return true // 如果数组里有为空的值，那直接返回true
        }
      }
      let str1 = ''
      result.forEach((v) => {
        str1 = str1 + v
      })
      // console.log(str1)
      // console.log(this.shopItemInfo)
      if (this.shopItemInfo[str1.trim()]) {
        return (
          this.shopItemInfo[str1.trim()]
          // &&
          // Number(this.shopItemInfo[str1.trim()].sku_stock) > 0 
        ) // 匹配选中的数据的库存，若不为空返回true反之返回false
      } else {
        let str2 = ''
        result.forEach((v) => {
          str2 = v + str2
        })
        return (
          this.shopItemInfo[str2.trim()]
          // &&
          // Number(this.shopItemInfo[str2.trim()].sku_stock) > 0
        ) // 匹配选中的数据的库存，若不为空返回true反之返回false
      }
    },
    close_specs () {
      // console.log(1)
      this.$emit('specs', false)
    },
    long (v) {
      this.names = this.lgname + '(' + v + '米)'
    },
    gocar () {   
      if (this.stock == 0) {
        Toast('该商品已售完')
      return false
      }   
      if (this.login == 0) {
        this.$router.push('login')
        return
      }
      if (this.zhuo!= 1) {
        if (this.num == 0) {
        // this.$router.push('login')
        Toast('请选择数量')
        return
      }
      }
      if (this.gui) {
        if(this.lengths==0){
      this.lengths=1
      }else{
      }
        this.axios
          .post('addcart', {
            changjia: this.$route.query.c ? 1 : 2,
            keel: this.fg ? 1 : 2,
            meter: this.lengths,
            unit: this.pack,
            goods_id: this.$route.query.id,
            store_id: this.$store.state.shopid,
            goods_num: this.zhuo==0? this.num:this.zcnum,
            attr_id: this.gid,
            name: this.names,
            units: this.dan,
            rate: this.one,
            sku_code: this.sad,
            ishuodong:this.zhuo,
            jianlou:this.jianlou,
            goods_basic_id:this.basid,
            zengpin:this.zeng,
            buyzengpinnum:this.zqnum,
            fanli_rate:this.fan,
       fanli_enable: this.fane,

            goods_zengnum:this.zengsu,            
          })
          .then((res) => {
            if (res.data.code == 1004) {
              localStorage.setItem(
                'token',
                JSON.stringify({ id: res.data.token })
              )
              this.gocar()
            }
            Toast(res.data.msg)
          })
          .catch((ref) => { })
        // this.$router.push('car')
      } else {
        Toast('请选择规格')
      }
    },
    goorder () {
      if (this.stock == 0) {
        Toast('该商品已售完')
      return false
      }
      // console.log(this.lengths)
// console.log(this.ishuodong)
      // return false 
      if (this.login == 0) {
        this.$router.push('login')
        return
      }
      if (this.zhuo != 1) {
        if (this.num == 0) {
        // this.$router.push('login')
        Toast('请选择数量')

        return
      }
      }
     
      // console.log(this.all_money)
      // console.log(this.znum)
      // return false

      if (this.gui) {
         if(this.lengths==0){
      this.lengths=1
      }else{
      }
        this.$router.push({
          name: 'order',
          query: { id: 0,  },
          params: {
            type: 2,
            shopid: this.$route.query.sid ? this.$route.query.sid : this.$store.state.shopid,
            shopname: this.$store.state.shopname,
            money: +this.all_money,
            goods: [
              {
                changjia: this.$route.query.c ? 1 : 2,
                goods_id: this.$route.query.id,
                attr_id: this.gid,
                sku_thumb: this.img,
                name: this.names,
                price: this.pice,
                goods_num: this.zhuo==0? this.num : this.zcnum,
                unit: this.pack,
                units: this.dan,
                rate: this.one,
                sku_code: this.sad,
                keel: this.fg ? 1 : 2,
                meter: this.lengths,
                show_price:  this.pice,
                ispintuan:0,
                jianlou:this.jianlou,
                goods_basic_id:this.basid,
                give:Math.floor((this.zcnum/this.zqnum)*this.zengsu),
                zengpin:this.zeng,
                tf:this.tf,
                fanli_rate:this.fan,
       fanli_enable: this.fane,

                ishuodong:this.zhuo

              },
            ],
          },
        })
      } else {
        Toast('请选择规格')
      }
    },
    see (i) {
      ImagePreview([i])
    },
  },
}
</script>
<style lang="less" scoped>
.zeng{
  margin-top: 0.2rem;
  color: rgb(249, 70, 70);
  text-align: right;
  padding-right: 0.3rem;
  // position: fixed;
  // top: 8.2rem;
  // right: 2%;
  // z-index: 999;
}
.hui {
  position: fixed;
  width: 100%;
  height: 5rem;
  top: 8rem;
  left: 0;
  background-color: #fff;
  z-index: 999;
}
.specs {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  .mongolia {
    width: 100%;
    height: 30%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .top {
    position: relative;
    overflow-y: scroll;
    height: 70%;
    background-color: #fff;
    width: 100%;
    padding-top: 2.746667rem;
    padding-bottom: 1.333333rem;
    .productBox {
      width: 100%;
      background-color: #fff;
    }
    .productConten {
      margin-bottom: 0.1rem;
    }
    .product-delcom {
      padding: 0.3rem;
      color: #323232;
      font-size: 0.36rem;
      p {
        font-size: 0.42rem;
        padding: 0.2rem;
        padding-left: 0;
      }
    }
    .product-footerlist {
      margin-top: 0.1rem;
    }
    .product-footerlist li {
      font-size: 0.37rem;
      border: 1px solid #606060;
      border-radius: 0.08rem;
      color: #606060;
      text-align: center;
      padding: 0.1rem 0.2rem;
      float: left;
      // width: 31%;
      margin-right: 0.16rem;
      min-width: 0.96rem;
      margin-bottom: 0.16rem;
    }
    .product-footerlist li.productActive {
      background-color: #a22d2b;
      color: #fff;
      border: 1px solid #a22d2b;
    }
    .product-footerlist li.noneActive {
      background-color: rgba(55, 55, 55, 0.5);
      // opacity: 0.4;
      color: rgb(199, 196, 196);
      pointer-events: none;
    }
    .product-footer {
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-flex: 1;
      -webkit-box-flex: 1;
      flex: 1;
      background-color: #1a1a29;
      line-height: 1rem;
      text-align: center;
    }
    .product-footer a {
      -webkit-flex: 1;
      -webkit-box-flex: 1;
      flex: 1;
      color: #fff;
      font-size: 0.3rem;
      text-decoration: none;
    }
    .card {
      width: 100%;
      position: fixed;
      top: 30%;
    }
    .title {
      padding-top: 0.4rem;
      font-size: 0.38rem;
    }
    .pricehua{
          overflow: hidden;
    color: #a53333;
    font-size: .43rem;
    text-decoration: line-through;
     span {
        padding-top: 0.1rem;
        font-size: 0.33rem;
        // padding-left: 0.2rem;
        display: block;
        // float: right;
        color: #333;
        img {
          margin-top: 0.1rem;
          width: 1rem;
          float: right;
        }
      }
    }
    .price {
      overflow: hidden;
      color: #a53333;
      font-size: 0.4rem;
      padding-bottom: 0.4rem;
      span {
        padding-top: 0.1rem;
        font-size: 0.3rem;
        padding-left: 0.2rem;
        display: block;
        float: right;
        color: #333;
        img {
          margin-top: 0.1rem;
          width: 1rem;
          float: right;
        }
      }
    }
    .knum {
      position: absolute;
      right: 0%;
      bottom: -14%;
      font-size: 0.35rem;
      p {
        float: left;
        line-height: 0.55rem;
        padding-right: 0.5rem;
      }
      span {
        font-size: 0.35rem;
      }
    }
    .close {
      font-size: 0.65rem;
      color: #a53535;
      position: absolute;
      right: 4%;
      top: 4%;
    }
    .details {
      padding-bottom: 0.2rem;
      .d_title {
        padding-left: 0.35rem;
        font-size: 0.43rem;
        height: 1rem;
        line-height: 1rem;
      }
      .d_specs {
        padding-left: 0.25rem;
        .d_list {
          margin-left: 0.1rem;
          padding: 0 0.2rem;
          height: 0.72rem;
          text-align: center;
          border: 1px solid #757575;
          border-radius: 3px;
          float: left;
          line-height: 0.7rem;
          color: #757575;
          margin-bottom: 0.2rem;
        }
        .selected {
          border-color: #a53535;
          color: #a53535;
        }
        .ash {
          border-color: #e3e3e3;
          color: #e3e3e3;
        }
      }
    }

    .num {
      color: #757575;
      padding: 0.3rem 0.35rem;
      display: flex;
      p {
        line-height: 0.85rem;
        font-size: 0.43rem;
        flex: 1;
      }
      .stepper {
        flex: 1;
        text-align: right;
      }
    }
    .prices {
      padding: 0.35rem 0.5rem;
      text-align: right;
      .p_num {
        font-size: 0.426667rem;
        color: #666;
        span {
          font-size: 0.45rem;
          color: #a22d28;
          padding-right: 0.5rem;
        }
      }
    }
    .buts {
      width: 100%;
      position: fixed;
      bottom: 0;
    }
    .but {
      width: 50%;
      float: left;
    }
    .butt{
      width: 100%;
    }
  }
}

</style>
